import type { Coordinate } from "@mm/api.meteomatics.com";

export enum PopupPlotType {
  ActiveLayers = "ActiveLayers",
  PointForecast = "PointForecast",
  Tephigram = "Tephigram",
  CrossSection = "CrossSection",
}

export interface PopupPlotState {
  hideLegend?: boolean;
  type: PopupPlotType;
  coords: Coordinate | null;
}

export const initialPopupPlotState: PopupPlotState = {
  hideLegend: false,
  type: PopupPlotType.ActiveLayers,
  coords: null,
};
